module.exports = __webpack_public_path__ + "static/media/t-shirt.c49dff4c.jpg";